module.exports = __webpack_public_path__ + "img/lucky_bk_p1.8596b334.png";